// extracted by mini-css-extract-plugin
module.exports = {"featuredImage":"styles_featuredImage__3q8uZ","featuredImageContent":"styles_featuredImageContent__62sCN"};